var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"isolation":"isolate"},attrs:{"viewBox":"0 0 200 200","width":"0.6em","height":"0.6em"}},[_c('path',{attrs:{"fill":_vm.color,"d":" M 0 100 L 100 0 L 200 100 L 100 200 L 0 100 Z "}})])}
var staticRenderFns = []

export { render, staticRenderFns }